import React from "react";

import { css, cx } from "@emotion/css";
import { useTranslation } from "react-i18next";

import { usePatientIdFromURL } from "@/hooks/usePatientIdFromURL.ts";
import { useStyles } from "@/hooks/useStyles.ts";
import { Queries } from "@/queries/Queries.ts";
import { Card } from "@/uiKit/atoms/Card.tsx";
import { CardContent } from "@/uiKit/atoms/CardContent.tsx";
import { CardFooter } from "@/uiKit/atoms/CardFooter.tsx";
import { CardHeader } from "@/uiKit/atoms/CardHeader.tsx";
import { Typography } from "@/uiKit/atoms/Typography.tsx";
import { CarePlansTable } from "@/uiKit/molecules/CarePlan/CarePlansTable.tsx";

export type CarePlansHistoryCardProps = {
  onClose?: () => void;
  className?: string;
};

export const CarePlansHistoryCard: React.FC<CarePlansHistoryCardProps> = ({ onClose, className }) => {
  const styles = useStyles(makeStyles);
  const { t } = useTranslation();

  return (
    <Card className={cx(styles.container, className)}>
      <CardHeader
        id="care-plan-history-header"
        title={t("carePlans.historyTitle")}
        variant="contained"
        onExit={onClose}
      />
      <CardContent>
        <CarePlansHistoryCardContent />
      </CardContent>
      <CardFooter />
    </Card>
  );
};

const CarePlansHistoryCardContent: React.FC = () => {
  const { t } = useTranslation();
  const styles = useStyles(makeStyles);

  const patientId = usePatientIdFromURL();
  const carePlans = Queries.practitioner.useCarePlanHistory(patientId);

  if (!carePlans.length) {
    return (
      <Typography variant="body" className={styles.noContent}>
        {t("carePlans.noCarePlans")}
      </Typography>
    );
  }

  return <CarePlansTable carePlans={carePlans} />;
};

const makeStyles = () => ({
  container: css({}),
  noContent: css({
    fontStyle: "italic",
  }),
});
